import { reasons } from "@/mocks/home";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

function ReasonCard({ reason, index }: { reason: typeof reasons[0]; index: number }) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div
      ref={ref}
      className={`group relative bg-background-100 border border-primary-500/40 rounded-xl p-6 md:p-8 hover:border-primary-500 transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="flex flex-col items-center text-center">

        <i className={`${reason.icon} text-accent-400 text-4xl md:text-6xl pb-6`}></i>

        <h3 className="text-accent-300 text-lg md:text-xl font-bold font-heading mb-3">
          {reason.title}
        </h3>
        <p className="text-foreground-600 text-sm leading-relaxed whitespace-pre-line">
          {reason.description}
        </p>
      </div>
    </div>
  );
}

export default function Reasons() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();

  return (
    <section id="reasons" className="relative py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div
            ref={titleRef}
            className={`text-center mb-12 md:mb-16 transition-all duration-700 ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
          >
            <h2 className="flex items-center justify-center gap-4 md:gap-8 text-2xl md:text-4xl lg:text-5xl font-black font-heading text-foreground-50">
              <span className="w-16 md:w-52 h-px bg-gradient-to-l from-primary-500 to-transparent" />
              選ばれる理由
              <span className="w-16 md:w-52 h-px bg-gradient-to-r from-primary-500 to-transparent" />
            </h2>
            <p className="text-primary-400 text-sm">WHY CHOOSE US</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {reasons.map((reason, index) => (
              <ReasonCard key={reason.id} reason={reason} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}